import React from 'react';
import './index.scss';

const DialogHeading = ({ title, description, icon }) => (
  <div className="dialogHeading">
    {icon && <span className="dialogHeading-icon" aria-hidden="true">{icon}</span>}
    <div className="dialogHeading-copy">
      <span className="dialogHeading-title">{title}</span>
      {description && <p>{description}</p>}
    </div>
  </div>
);

export default DialogHeading;
